/**
 * Matchmaker request (F11).
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md task 7.18, PRD F11
 */
import type { MatchmakerQuery, MatchmakerResult } from '@nexus/contracts';

import { api } from '../../../lib/api-client';

export async function matchStartupToAssets(
  query: MatchmakerQuery,
): Promise<MatchmakerResult> {
  return api.get<MatchmakerResult>('/matchmaker', { query });
}
